// extracted by mini-css-extract-plugin
export default {"text":"styles_text__y7Iak","title":"styles_title__HwgTY"};